// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./Tickets.module.css";
// CSS
// Images
import { quiz_jame_header } from "../../../Images/images";
import { getUserTicketsService } from "../../../Services/Profile/get/getUserTicketsService";
import { UserTokenContext } from "../../../Contexts/userToken";
import TicketCard from "./TicketCard/TicketCard";
import { I_Ticket, I_TicketingSlides } from "../../../Models/interfaces";
import PendingManager from "../../../Components/PendingManager/PendingManager";
import { Link, useNavigate } from "react-router-dom";
// Images

import { BiArrowBack, BiCommentAdd } from "react-icons/bi";
import { toast } from "react-toastify";
import TicketSlidesBanner from "./TicketSlidesBanner/TicketSlidesBanner";
import TicketManager from "./TicketManager/TicketManager";
import TicketAdder from "./TicketManager/TicketAdder/TicketAdder";

type TicketsProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Tickets: React.FunctionComponent<TicketsProps> = ({
  setIsNeedFullScreen,
}) => {
  const [tickets, setTickets] = useState<I_Ticket[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  const userToken = useContext(UserTokenContext);

  useEffect(() => {
    getUserTicketsService(userToken)
      .then(({ data }) => {
        setTickets(data);
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message,
        );
      });
  }, [userToken]);

  useEffect(() => {
    setIsNeedFullScreen(true);
    return () => {
      setIsNeedFullScreen(false);
    };
  });

  const navigate = useNavigate();

  return (
    <div
      className={`${styles.ticketsMainContainer} overflow-y-scroll relative `}
    >
      <div className="flex flex-row-reverse items-center justify-between mt-4 px-4 pt-1 pb-3">
        <h1 className=" ">تیکت های شما</h1>

        <BiArrowBack
          className="text-2xl"
          onClick={() => {
            navigate(-1);
          }}
        />
      </div>
      {/* <img src={quiz_jame_header} alt="" className="h-40 w-full" /> */}
      <TicketSlidesBanner />

      <TicketAdder hideBackArrow/>
      <br />
      <br />
      {/* <Link
        to={"/profile/tickets/add"}
        className="mx-5  text-center flex items-center justify-center my-2 fixed bottom-[8vh] rounded-full p-3 text-xl "
        style={{
          background: `rgb(82,109,254)`,
        }}
      >
        <BiCommentAdd fill="white" />
      </Link> */}
      <PendingManager
        isPending={isPending}
        data={
          <div className={`${styles.ticketsContainer} mb-[16vh]`}>
            {tickets.length === 0 ? (
              <p className="w-full text-center text-xl mt-10">
                هنوز هیچ تیکتی ثبت نشده
              </p>
            ) : (
              <>
                {tickets.map((item) => (
                  <TicketCard key={item.id} data={item} />
                ))}
              </>
            )}
          </div>
        }
      />
    </div>
  );
};

export default Tickets;
